import { HandicappingTab } from "../../../types";
import { buildQaLabel } from "../../../utils/general";

const BASE = "handicapping";
const RUNNER = "runner";
const RACE = "race";
const COMMENT = "comment";
const TALENT_PICKS = "talent-picks";

export const HEADER_QA_LABEL = {
  TITLE: buildQaLabel([BASE, "title"]),
  FILTERS: buildQaLabel([BASE, "filters"]),
  BADGE: buildQaLabel([BASE, "badge"])
};

export const COMMENTS_QA_LABEL = {
  HEADER: buildQaLabel([BASE, COMMENT, "header"]),
  RACE: buildQaLabel([BASE, COMMENT, RACE]),
  RUNNER: buildQaLabel([BASE, COMMENT, RUNNER])
};

export const RUNNERS_QA_LABEL = {
  CONTAINER: buildQaLabel([BASE, RUNNER, "container"]),
  RUNNER: buildQaLabel([BASE, RUNNER, "row"]),
  SADDLE: buildQaLabel([BASE, RUNNER, "saddle"]),
  NAME: buildQaLabel([BASE, RUNNER, "name"])
};

export const TALENT_PICKS_QA_LABEL = {
  CONTAINER: buildQaLabel([BASE, TALENT_PICKS, "container"]),
  PICK: buildQaLabel([BASE, TALENT_PICKS])
};

export const talentPickTab: HandicappingTab = {
  icon: "tvgPicks",
  name: "FDTV Picks",
  value: "talentPick"
};
